import React from 'react';
import styled from 'styled-components';

interface ArticleHeaderProps {
  h1: string;
  h2: string;
  headerImage?: React.ReactNode;
}

const SCArticleHeader = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 1rem 0;
  margin-bottom: 1rem;
  .titles {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 1rem;
    h1 {
      font-size: 1.5rem;
    }
    h2 {
      font-size: 1.2rem;
    }
  }
  .headerImage {
    max-width: 400px;
  }
  @media screen and (min-width: 800px) {
    .titles {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      max-width: 50%;
      h1 {
        font-size: 3rem;
      }
      h2 {
        font-size: 1.5rem;
      }
    }
  }
`;

export function ArticleHeader(props: ArticleHeaderProps) {
  return (
    <header>
      <div className="container-full">
        <SCArticleHeader>
          <div className="titles">
            <h1>{props.h1}</h1>
            {/* <h2 style={{display: props.h2 ? 'initial' : 'none'}}>{props.h2}</h2> */}
            {props.h2 && <h2>{props.h2}</h2>}
          </div>
          {/* <div
            className="headerImage"
            style={{display: props.headerImage ? 'initial' : 'none'}}
          >
            {props.headerImage}
          </div> */}
          {props.headerImage && (
            <div className="headerImage">{props.headerImage}</div>
          )}
        </SCArticleHeader>
      </div>
    </header>
  );
}
